module.exports = __webpack_public_path__ + "static/media/cut3.f80a30a2.webm";